import { useTranslation } from '../../i18n'
import './WhyIntervio.css'

function WhyIntervio() {
  const { t } = useTranslation()

  const booleanRows = [
    { key: 'whyIntervioRow1' as const, intervio: true, others: false },
    { key: 'whyIntervioRow2' as const, intervio: true, others: false },
    { key: 'whyIntervioRow3' as const, intervio: true, others: false },
    { key: 'whyIntervioRow6' as const, intervio: true, others: false },
  ]

  return (
    <section className="why-intervio-section section" aria-label="Why Intervio">
      <div className="container">
        <div className="section-title">
          <h2>{t('whyIntervioTitle')}</h2>
          <p>{t('whyIntervioSubtitle')}</p>
        </div>

        <div className="comparison-table-wrapper">
          <table className="comparison-table">
            <thead>
              <tr>
                <th className="feature-col">{t('whyIntervioFeature')}</th>
                <th className="intervio-col">
                  <span className="col-badge intervio">{t('whyIntervioIntervio')}</span>
                </th>
                <th className="others-col">{t('whyIntervioOthers')}</th>
              </tr>
            </thead>
            <tbody>
              {booleanRows.map((row) => (
                <tr key={row.key}>
                  <td className="feature-col">{t(row.key)}</td>
                  <td className="intervio-col">
                    <span className="check-yes">✓</span>
                  </td>
                  <td className="others-col">
                    <span className="check-no">✗</span>
                  </td>
                </tr>
              ))}
              {/* Platform row */}
              <tr>
                <td className="feature-col">{t('whyIntervioRow5')}</td>
                <td className="intervio-col">
                  <span className="value-highlight">{t('whyIntervioRow5Intervio')}</span>
                </td>
                <td className="others-col">
                  <span className="value-muted">{t('whyIntervioRow5Others')}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  )
}

export default WhyIntervio
